import { WWOTopReferringIndustriesTable } from "app/pages/website-performance/components/TopReferringIndustries/WWOTopReferringIndustriesTable";
import { DEFAULT_HOOKS_MODAL_ID } from "app/pages/workspace/config/stateToWsConfigMap";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const WWOTopReferringIndustriesContainerSI = () => {
    const params = proNavigator.getParams();

    const getCtaLink = () => {
        return {
            href: proNavigator.href("accountreview_website_referrals_incomingtraffic", params),
            target: "_self",
        };
    };
    return (
        <WWOTopReferringIndustriesTable
            getCtaLink={getCtaLink}
            unlockHook={{
                component: "WebReferralIncomingTraffic",
                hookModal: DEFAULT_HOOKS_MODAL_ID,
            }}
        />
    );
};
